const els = {
    $hero: () => $('[data-hero]'),
    $overlay: () => els.$hero().find('[data-overlay]'),
    $overlayText: () => els.$overlay().find('[data-text]'),
    $popup: () => els.$hero().find('[data-popup]'),
    $frame: () => els.$popup().find('[data-frame]'),
    $iframe: () => els.$popup().find('iframe'),
    $closeButton: () => els.$popup().find('[data-close]'),
    $clickout: () => els.$popup().find('[data-clickout]'),
};

export default els;

